import React from "react";
import { Button } from "antd";
import { ContainerModal } from "../container/ContainerModal";

export const ModalUpdateTime = ({ closeModalDetails }) => {

	return (
		<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
			<ContainerModal
				title={"Actualizar Tiempo"}
				actionButton={() => {
					closeModalDetails();
				}}
				className={"w-[500px]"}
			>
				<div>
					<p className="text-[12px]">Se va actualizar el tiempo con lo que hay en clickup</p>
					<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
						<Button
							onClick={() => {
								// editFormForProjectDetails()
							}}
							type="primary"
							className="bg-primaryTwo"
						>
							Actualizar
						</Button>
					</div>
				</div>
			</ContainerModal>
		</div>
	);
};
